import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { MenuButton } from '../../model/menu-button';

@Component({
    selector: 'app-button-menu',
    templateUrl: './button-menu.component.html',
    styleUrls: ['./button-menu.component.scss']
})
export class ButtonMenuComponent {
    @Input()
    buttons: MenuButton[];

    constructor(
        private router: Router,
        private acivated: ActivatedRoute
    ) { }

    handleClick(button: MenuButton): void {
        if (!isEmpty(button.routerLink)) {
            this.router
                .navigate([button.routerLink], { relativeTo: this.acivated })
                .catch(err => console.error(err));
        } else if (!isEmpty(button.externalLink)) {
            window.open(button.externalLink, '_blank');
        } else if (button.onClick != null) {
            button.onClick();
        } else console.error('unknow option selected');
    }
}

